import studentRequest from 'utils/studentRequest'
import { filenameForMimeType } from 'utils/audioFormat'
import { useSelector, useDispatch } from 'react-redux'
import axios from 'axios'
import { Modal } from 'antd'
import {
  markAssessmentStarted,
  hasAssessmentMarker,
  clearAssessmentMarker,
} from 'utils/assessmentSession'

export const ASSESSMENT_TYPES = {
  FETCH_QUESTIONS_REQUEST: 'FETCH_QUESTIONS_REQUEST',
  FETCH_QUESTIONS_SUCCESS: 'FETCH_QUESTIONS_SUCCESS',
  FETCH_QUESTIONS_FAILURE: 'FETCH_QUESTIONS_FAILURE',
  SAVE_QUESTION_RESPONSE: 'SAVE_QUESTION_RESPONSE',
  FETCH_ACTIVE_ASSESSMENTS_REQUEST: 'FETCH_ACTIVE_ASSESSMENTS_REQUEST',
  FETCH_ACTIVE_ASSESSMENTS_SUCCESS: 'FETCH_ACTIVE_ASSESSMENTS_SUCCESS',
  FETCH_ACTIVE_ASSESSMENTS_FAILURE: 'FETCH_ACTIVE_ASSESSMENTS_FAILURE',
  FETCH_COMPLETED_ASSESSMENTS_REQUEST: 'FETCH_COMPLETED_ASSESSMENTS_REQUEST',
  FETCH_COMPLETED_ASSESSMENTS_SUCCESS: 'FETCH_COMPLETED_ASSESSMENTS_SUCCESS',
  FETCH_COMPLETED_ASSESSMENTS_FAILURE: 'FETCH_COMPLETED_ASSESSMENTS_FAILURE',
  SET_ACTIVE_ASSESSMENT_FILTERS: 'SET_ACTIVE_ASSESSMENT_FILTERS',
  SET_COMPLETED_ASSESSMENT_FILTERS: 'SET_COMPLETED_ASSESSMENT_FILTERS',
  SET_CURRENT_ASSESSMENT_ID: 'SET_CURRENT_ASSESSMENT_ID',
  SAVE_ASSESSMENT_RESPONSE: 'SAVE_ASSESSMENT_RESPONSE',
  SAVE_RESPONSE_REQUEST: 'SAVE_RESPONSE_REQUEST',
  SAVE_RESPONSE_SUCCESS: 'SAVE_RESPONSE_SUCCESS',
  SAVE_RESPONSE_FAILURE: 'SAVE_RESPONSE_FAILURE',
  SUBMIT_ASSESSMENT_REQUEST: 'SUBMIT_ASSESSMENT_REQUEST',
  SUBMIT_ASSESSMENT_SUCCESS: 'SUBMIT_ASSESSMENT_SUCCESS',
  SUBMIT_ASSESSMENT_FAILURE: 'SUBMIT_ASSESSMENT_FAILURE',
  FETCH_REPORTS_REQUEST: 'FETCH_REPORTS_REQUEST',
  FETCH_REPORTS_SUCCESS: 'FETCH_REPORTS_SUCCESS',
  FETCH_REPORTS_FAILURE: 'FETCH_REPORTS_FAILURE',
  SET_COMMUNICATION_QUESTIONS: 'SET_COMMUNICATION_QUESTIONS',
  RESET_RESPONSES: 'RESET_RESPONSES',
  SET_CURRENT_ASSESSMENT_INSTRUCTIONS: 'SET_CURRENT_ASSESSMENT_INSTRUCTIONS',
  STORE_VIDEO_RESPONSE: 'STORE_VIDEO_RESPONSE',
  STORE_AUDIO_RESPONSE: 'STORE_AUDIO_RESPONSE',
  // Keep these action types but remove the checkPracticeAccess function
  CHECK_PRACTICE_ACCESS_REQUEST: 'CHECK_PRACTICE_ACCESS_REQUEST',
  CHECK_PRACTICE_ACCESS_SUCCESS: 'CHECK_PRACTICE_ACCESS_SUCCESS',
  CHECK_PRACTICE_ACCESS_FAILURE: 'CHECK_PRACTICE_ACCESS_FAILURE',
  FETCH_PRACTICE_HISTORY_REQUEST: 'FETCH_PRACTICE_HISTORY_REQUEST',
  FETCH_PRACTICE_HISTORY_SUCCESS: 'FETCH_PRACTICE_HISTORY_SUCCESS',
  FETCH_PRACTICE_HISTORY_FAILURE: 'FETCH_PRACTICE_HISTORY_FAILURE',
  GENERATE_PDF_REPORT_REQUEST: 'GENERATE_PDF_REPORT_REQUEST',
  GENERATE_PDF_REPORT_SUCCESS: 'GENERATE_PDF_REPORT_SUCCESS',
  GENERATE_PDF_REPORT_FAILURE: 'GENERATE_PDF_REPORT_FAILURE',
  CHECK_RETAKE_ELIGIBILITY_REQUEST: 'CHECK_RETAKE_ELIGIBILITY_REQUEST',
  CHECK_RETAKE_ELIGIBILITY_SUCCESS: 'CHECK_RETAKE_ELIGIBILITY_SUCCESS',
  CHECK_RETAKE_ELIGIBILITY_FAILURE: 'CHECK_RETAKE_ELIGIBILITY_FAILURE',
  TICK_QUESTION_TIME: 'TICK_QUESTION_TIME',
  PAUSE_QUESTION_TIME: 'PAUSE_QUESTION_TIME',
  RESET_QUESTION_TIME: 'RESET_QUESTION_TIME',
  INIT_QUESTION_TIME: 'INIT_QUESTION_TIME',
  COMPLETE_ASSESSMENT: 'COMPLETE_ASSESSMENT',
  RESET_ASSESSMENT_STATE: 'RESET_ASSESSMENT_STATE',
  FETCH_SOLUTIONS_REQUEST: 'FETCH_SOLUTIONS_REQUEST',
  FETCH_SOLUTIONS_SUCCESS: 'FETCH_SOLUTIONS_SUCCESS',
  FETCH_SOLUTIONS_FAILURE: 'FETCH_SOLUTIONS_FAILURE',
  FETCH_APTITUDE_SCORE_REQUEST: 'FETCH_APTITUDE_SCORE_REQUEST',
  FETCH_APTITUDE_SCORE_SUCCESS: 'FETCH_APTITUDE_SCORE_SUCCESS',
  FETCH_APTITUDE_SCORE_FAILURE: 'FETCH_APTITUDE_SCORE_FAILURE',
  FETCH_ACTIVITY_MAP_REQUEST: 'FETCH_ACTIVITY_MAP_REQUEST',
  FETCH_ACTIVITY_MAP_SUCCESS: 'FETCH_ACTIVITY_MAP_SUCCESS',
  FETCH_ACTIVITY_MAP_FAILURE: 'FETCH_ACTIVITY_MAP_FAILURE',
  SET_ACTIVITY_DATE_RANGE: 'SET_ACTIVITY_DATE_RANGE',
  FETCH_COMPLETED_PRACTICE_ASSESSMENTS_REQUEST:
    'FETCH_COMPLETED_PRACTICE_ASSESSMENTS_REQUEST',
  FETCH_COMPLETED_PRACTICE_ASSESSMENTS_SUCCESS:
    'FETCH_COMPLETED_PRACTICE_ASSESSMENTS_SUCCESS',
  FETCH_COMPLETED_PRACTICE_ASSESSMENTS_FAILURE:
    'FETCH_COMPLETED_PRACTICE_ASSESSMENTS_FAILURE',
  // Merged PlacementPrep action types
  FETCH_PRACTICE_SCORES_REQUEST: 'FETCH_PRACTICE_SCORES_REQUEST',
  FETCH_PRACTICE_SCORES_SUCCESS: 'FETCH_PRACTICE_SCORES_SUCCESS',
  FETCH_PRACTICE_SCORES_FAILURE: 'FETCH_PRACTICE_SCORES_FAILURE',
  FETCH_APTITUDE_PRACTICE_SCORES_REQUEST:
    'FETCH_APTITUDE_PRACTICE_SCORES_REQUEST',
  FETCH_APTITUDE_PRACTICE_SCORES_SUCCESS:
    'FETCH_APTITUDE_PRACTICE_SCORES_SUCCESS',
  FETCH_APTITUDE_PRACTICE_SCORES_FAILURE:
    'FETCH_APTITUDE_PRACTICE_SCORES_FAILURE',

  FETCH_DROPOUT_ASSESSMENTS_REQUEST: 'FETCH_DROPOUT_ASSESSMENTS_REQUEST',
  FETCH_DROPOUT_ASSESSMENTS_SUCCESS: 'FETCH_DROPOUT_ASSESSMENTS_SUCCESS',
  FETCH_DROPOUT_ASSESSMENTS_FAILURE: 'FETCH_DROPOUT_ASSESSMENTS_FAILURE',
  SET_DROPOUT_ASSESSMENT_FILTERS: 'SET_DROPOUT_ASSESSMENT_FILTERS',


  CHECK_STUDENT_CORPORATE_STATUS_REQUEST: 'CHECK_STUDENT_CORPORATE_STATUS_REQUEST',
  CHECK_STUDENT_CORPORATE_STATUS_SUCCESS: 'CHECK_STUDENT_CORPORATE_STATUS_SUCCESS',
  CHECK_STUDENT_CORPORATE_STATUS_FAILURE: 'CHECK_STUDENT_CORPORATE_STATUS_FAILURE',
  LOAD_DIRECT_ASSESSMENT_REQUEST: 'LOAD_DIRECT_ASSESSMENT_REQUEST',
  LOAD_DIRECT_ASSESSMENT_SUCCESS: 'LOAD_DIRECT_ASSESSMENT_SUCCESS',
  LOAD_DIRECT_ASSESSMENT_FAILURE: 'LOAD_DIRECT_ASSESSMENT_FAILURE',

  FETCH_BEHAVIOUR_SPECIALISATIONS_REQUEST: 'FETCH_BEHAVIOUR_SPECIALISATIONS_REQUEST',
  FETCH_BEHAVIOUR_SPECIALISATIONS_SUCCESS: 'FETCH_BEHAVIOUR_SPECIALISATIONS_SUCCESS',
  FETCH_BEHAVIOUR_SPECIALISATIONS_FAILURE: 'FETCH_BEHAVIOUR_SPECIALISATIONS_FAILURE',
  SAVE_BEHAVIOUR_SPECIALISATION_REQUEST: 'SAVE_BEHAVIOUR_SPECIALISATION_REQUEST',
  SAVE_BEHAVIOUR_SPECIALISATION_SUCCESS: 'SAVE_BEHAVIOUR_SPECIALISATION_SUCCESS',
  SAVE_BEHAVIOUR_SPECIALISATION_FAILURE: 'SAVE_BEHAVIOUR_SPECIALISATION_FAILURE',
}

// Action creators
export const fetchQuestionsRequest = () => ({
  type: ASSESSMENT_TYPES.FETCH_QUESTIONS_REQUEST,
})

export const fetchQuestionsSuccess = data => ({
  type: ASSESSMENT_TYPES.FETCH_QUESTIONS_SUCCESS,
  payload: data,
})

export const fetchQuestionsFailure = error => ({
  type: ASSESSMENT_TYPES.FETCH_QUESTIONS_FAILURE,
  payload: error,
})

export const fetchActiveAssessmentsRequest = () => ({
  type: ASSESSMENT_TYPES.FETCH_ACTIVE_ASSESSMENTS_REQUEST,
})

export const fetchActiveAssessmentsSuccess = data => ({
  type: ASSESSMENT_TYPES.FETCH_ACTIVE_ASSESSMENTS_SUCCESS,
  payload: data,
})

export const fetchActiveAssessmentsFailure = error => ({
  type: ASSESSMENT_TYPES.FETCH_ACTIVE_ASSESSMENTS_FAILURE,
  payload: error,
})

export const fetchCompletedAssessmentsRequest = () => ({
  type: ASSESSMENT_TYPES.FETCH_COMPLETED_ASSESSMENTS_REQUEST,
})

export const fetchCompletedAssessmentsSuccess = data => ({
  type: ASSESSMENT_TYPES.FETCH_COMPLETED_ASSESSMENTS_SUCCESS,
  payload: data,
})

export const fetchCompletedAssessmentsFailure = error => ({
  type: ASSESSMENT_TYPES.FETCH_COMPLETED_ASSESSMENTS_FAILURE,
  payload: error,
})

export const setActiveAssessmentFilters = filters => ({
  type: ASSESSMENT_TYPES.SET_ACTIVE_ASSESSMENT_FILTERS,
  payload: filters,
})

export const setCompletedAssessmentFilters = filters => ({
  type: ASSESSMENT_TYPES.SET_COMPLETED_ASSESSMENT_FILTERS,
  payload: filters,
})

export const resetResponses = () => ({
  type: ASSESSMENT_TYPES.RESET_RESPONSES,
})

export const setCurrentAssessmentId = assessment => ({
  type: ASSESSMENT_TYPES.SET_CURRENT_ASSESSMENT_ID,
  payload: {
    assessment_id: assessment.id,
    assessment_set_id: assessment.assessment_set_id,
    assessment_assigned_id: assessment.assessment_assigned_id,
    allowProctoring: assessment.allowProctoring,
    allowVerification: assessment.allowVerification,
    title: assessment.title,
    type: assessment.type,
    isPractice: assessment.isPractice,
    isCorporate: assessment.isCorporate
  },
})

export const setCurrentAssessmentInstructions = instructions => ({
  type: ASSESSMENT_TYPES.SET_CURRENT_ASSESSMENT_INSTRUCTIONS,
  payload: instructions,
})

export const fetchReportsRequest = () => ({
  type: ASSESSMENT_TYPES.FETCH_REPORTS_REQUEST,
})

export const fetchReportsSuccess = reports => ({
  type: ASSESSMENT_TYPES.FETCH_REPORTS_SUCCESS,
  payload: reports,
})

export const fetchReportsFailure = error => ({
  type: ASSESSMENT_TYPES.FETCH_REPORTS_FAILURE,
  payload: error,
})

export const fetchPracticeHistoryRequest = () => ({
  type: ASSESSMENT_TYPES.FETCH_PRACTICE_HISTORY_REQUEST,
})

export const fetchPracticeHistorySuccess = data => ({
  type: ASSESSMENT_TYPES.FETCH_PRACTICE_HISTORY_SUCCESS,
  payload: data,
})

export const fetchPracticeHistoryFailure = error => ({
  type: ASSESSMENT_TYPES.FETCH_PRACTICE_HISTORY_FAILURE,
  payload: error,
})

export const generatePDFReportRequest = () => ({
  type: ASSESSMENT_TYPES.GENERATE_PDF_REPORT_REQUEST,
})

export const generatePDFReportSuccess = data => ({
  type: ASSESSMENT_TYPES.GENERATE_PDF_REPORT_SUCCESS,
  payload: data,
})

export const generatePDFReportFailure = error => ({
  type: ASSESSMENT_TYPES.GENERATE_PDF_REPORT_FAILURE,
  payload: error,
})

export const checkRetakeEligibilityRequest = () => ({
  type: ASSESSMENT_TYPES.CHECK_RETAKE_ELIGIBILITY_REQUEST,
})

export const checkRetakeEligibilitySuccess = data => ({
  type: ASSESSMENT_TYPES.CHECK_RETAKE_ELIGIBILITY_SUCCESS,
  payload: data,
})

export const checkRetakeEligibilityFailure = error => ({
  type: ASSESSMENT_TYPES.CHECK_RETAKE_ELIGIBILITY_FAILURE,
  payload: error,
})

// Timer action creators
export const tickQuestionTime = questionId => ({
  type: ASSESSMENT_TYPES.TICK_QUESTION_TIME,
  payload: { questionId },
})

export const pauseQuestionTime = questionId => ({
  type: ASSESSMENT_TYPES.PAUSE_QUESTION_TIME,
  payload: { questionId },
})

export const resetQuestionTime = questionId => ({
  type: ASSESSMENT_TYPES.RESET_QUESTION_TIME,
  payload: { questionId },
})

export const initQuestionTime = questionId => ({
  type: ASSESSMENT_TYPES.INIT_QUESTION_TIME,
  payload: { questionId },
})

export const completeAssessment = assessmentData => ({
  type: ASSESSMENT_TYPES.COMPLETE_ASSESSMENT,
  payload: assessmentData,
})

export const resetAssessmentState = () => ({
  type: ASSESSMENT_TYPES.RESET_ASSESSMENT_STATE,
})

export const fetchActivityMapRequest = () => ({
  type: ASSESSMENT_TYPES.FETCH_ACTIVITY_MAP_REQUEST,
})

export const fetchActivityMapSuccess = data => ({
  type: ASSESSMENT_TYPES.FETCH_ACTIVITY_MAP_SUCCESS,
  payload: data,
})

export const fetchActivityMapFailure = error => ({
  type: ASSESSMENT_TYPES.FETCH_ACTIVITY_MAP_FAILURE,
  payload: error,
})

export const setActivityDateRange = (startDate, endDate) => ({
  type: ASSESSMENT_TYPES.SET_ACTIVITY_DATE_RANGE,
  payload: { startDate, endDate },
})

export const fetchCompletedPracticeAssessmentsRequest = () => ({
  type: ASSESSMENT_TYPES.FETCH_COMPLETED_PRACTICE_ASSESSMENTS_REQUEST,
})

export const fetchCompletedPracticeAssessmentsSuccess = data => ({
  type: ASSESSMENT_TYPES.FETCH_COMPLETED_PRACTICE_ASSESSMENTS_SUCCESS,
  payload: data,
})

export const fetchCompletedPracticeAssessmentsFailure = error => ({
  type: ASSESSMENT_TYPES.FETCH_COMPLETED_PRACTICE_ASSESSMENTS_FAILURE,
  payload: error,
})

export const fetchDropoutAssessmentsRequest = () => ({
  type: ASSESSMENT_TYPES.FETCH_DROPOUT_ASSESSMENTS_REQUEST,
})

export const fetchDropoutAssessmentsSuccess = data => ({
  type: ASSESSMENT_TYPES.FETCH_DROPOUT_ASSESSMENTS_SUCCESS,
  payload: data,
})

export const fetchDropoutAssessmentsFailure = error => ({
  type: ASSESSMENT_TYPES.FETCH_DROPOUT_ASSESSMENTS_FAILURE,
  payload: error,
})

export const setDropoutAssessmentFilters = filters => ({
  type: ASSESSMENT_TYPES.SET_DROPOUT_ASSESSMENT_FILTERS,
  payload: filters,
})


// Add these action creators if they don't exist
export const checkStudentCorporateStatusRequest = () => ({
  type: ASSESSMENT_TYPES.CHECK_STUDENT_CORPORATE_STATUS_REQUEST,
})

export const checkStudentCorporateStatusSuccess = data => ({
  type: ASSESSMENT_TYPES.CHECK_STUDENT_CORPORATE_STATUS_SUCCESS,
  payload: data,
})

export const checkStudentCorporateStatusFailure = error => ({
  type: ASSESSMENT_TYPES.CHECK_STUDENT_CORPORATE_STATUS_FAILURE,
  payload: error,
})



// In-flight de-duplication, keyed by assessment_assigned_id. Multiple call sites
// (instruction.js handleStart + aptitudeassmt/index.js prefetch) and React re-invokes
// can fire this concurrently; the backend regenerates the aptitude question set per
// fetch, so a duplicate request races and can repoint the assessment to a set the
// student never answered (-> 0 marks). Collapsing duplicates to a single request
// removes that trigger at the source.
const inFlightQuestionFetches = {}

// Reload guard for the OTP invite runner. Returns the state the runner should
// render: 'pending' | 'resume' (show instructions), 'dropout' | 'completed'
// (terminal screen). For a non-resumable attempt already INPROGRESS the backend
// marks it DROPOUT, so a reload cannot be used to retake the assessment.
export const checkInviteReloadGuard = async assessmentAssignedId => {
  const res = await studentRequest.post(
    '/students/assessments/invite/reloadGuard',
    { assessment_assigned_id: assessmentAssignedId }
  )
  const data = res?.data?.data || res?.data || {}
  return data.state || 'pending'
}

export const fetchAssessmentQuestions =
  assessmentAssignedId => async dispatch => {
    if (inFlightQuestionFetches[assessmentAssignedId]) {
      console.warn(
        `fetchAssessmentQuestions already in flight for ${assessmentAssignedId} — reusing existing request`
      )
      return inFlightQuestionFetches[assessmentAssignedId]
    }

    const request = (async () => {
      dispatch(resetResponses())
      dispatch(fetchQuestionsRequest())
      try {
        // If this browser already started this attempt, signal a resume so the
        // backend serves the questions again instead of rejecting it as
        // "in progress on another device".
        const isResume = hasAssessmentMarker(assessmentAssignedId)
        const res = await studentRequest.get(
          `/students/getAssessmentQuestions?assessment_assigned_id=${assessmentAssignedId}${
            isResume ? '&resume=true' : ''
          }`
        )

        if (res.data.message === 'success') {
          // This browser now owns the active attempt — record it for resume and
          // so it stays visible only here.
          markAssessmentStarted(assessmentAssignedId)
          dispatch(fetchQuestionsSuccess(res?.data))
          console.log('Assessment questions fetched successfully')
          return { success: true }
        } else {
          throw new Error('Failed to fetch assessment questions')
        }
      } catch (error) {
        // The single-active-attempt guard returns 409 with a machine-readable
        // code, and the window gate returns 410 (ASSESSMENT_WINDOW_CLOSED).
        // Both are terminal for this click: surface a clear message and do NOT
        // start the assessment.
        const status = error?.response?.status
        const code = error?.response?.data?.data?.code
        const serverMessage = error?.response?.data?.message
        if (status === 409 || status === 410) {
          // These are terminal for this browser: the attempt is finished or can
          // never be resumed here, so drop the stale in-progress marker.
          if (
            code === 'ALREADY_COMPLETED' ||
            code === 'RESUME_NOT_ALLOWED' ||
            code === 'ASSESSMENT_WINDOW_CLOSED'
          ) {
            clearAssessmentMarker(assessmentAssignedId)
          }
          const friendlyMessage =
            serverMessage ||
            (status === 410
              ? 'This assessment is no longer available.'
              : 'This assessment is already in progress on another device.')
          dispatch(fetchQuestionsFailure(friendlyMessage))
          // Guarantee the candidate sees why the assessment didn't start —
          // not every runtime renders questionsError on its instruction screen.
          // PROGRESSION_PENDING is transient (the previous assessment is still
          // being evaluated) — present it as "wait & retry", not a hard error.
          if (code === 'PROGRESSION_PENDING') {
            Modal.info({
              title: 'Almost ready',
              content: friendlyMessage,
              okText: 'OK',
              centered: true,
            })
          } else {
            Modal.warning({
              title: 'Assessment unavailable',
              content: friendlyMessage,
              centered: true,
            })
          }
          console.warn('Assessment start rejected:', code, friendlyMessage)
          return { success: false, code, message: friendlyMessage }
        }
        dispatch(fetchQuestionsFailure(error))
        console.error('Error fetching assessment questions:', error)
        return { success: false, error }
      } finally {
        delete inFlightQuestionFetches[assessmentAssignedId]
      }
    })()

    inFlightQuestionFetches[assessmentAssignedId] = request
    return request
  }

export const fetchCommunicationInstructions =
  assessment_set_id => async dispatch => {
    try {
      const queryParams = new URLSearchParams({
        assessment_set_id: assessment_set_id || '',
      }).toString()

      const res = await studentRequest.get(
        `students/getCommunicationInstructions?${queryParams}`
      )

      if (res.data.message === 'success') {
        dispatch({
          type: ASSESSMENT_TYPES.SET_CURRENT_ASSESSMENT_INSTRUCTIONS,
          payload: res.data.data.instructions,
        })
      } else {
        throw new Error('Failed to fetch communication instructions')
      }
    } catch (error) {
      console.error('Error fetching communication instructions:', error)
    }
  }

export const fetchBehaviourInstructions =
  assessment_set_id => async dispatch => {
    try {
      const queryParams = new URLSearchParams({
        assessment_set_id: assessment_set_id || '',
      }).toString()

      const res = await studentRequest.get(
        `students/getBehaviourInstructions?${queryParams}`
      )

      if (res.data.message === 'success') {
        dispatch({
          type: ASSESSMENT_TYPES.SET_CURRENT_ASSESSMENT_INSTRUCTIONS,
          payload: res.data.data.instructions,
        })
      } else {
        throw new Error('Failed to fetch behaviour instructions')
      }
    } catch (error) {
      console.error('Error fetching behaviour instructions:', error)
    }
  }

export const saveQuestionResponse =
  (questionId, answer, assessment_assigned_id, subQuestionId, questionType) =>
    async (dispatch, getState) => {
      try {
        dispatch({ type: ASSESSMENT_TYPES.SAVE_RESPONSE_REQUEST })

        const state = getState()
        const timeSpentPerQuestion = state.assessment.timeSpentPerQuestion || {}
        const timeTaken = timeSpentPerQuestion[questionId] || 0

        let payload;
        let answerForRedux; // This is what we'll store in Redux

        // FIXED: Handle different question types appropriately
        if (subQuestionId) {
          // For responses with subQuestionId (dictation, sentence completion, sentence build)
          payload = {
            questionId,
            assessment_assigned_id,
            timeTaken,
            answer: {
              subQuestionId,
              selectedOption: answer,
            },
          }
          answerForRedux = answer; // Store plain answer in Redux
        } else if (questionType === 'questionBasedResponse' || questionType === 'emailWriting') {
          // FIXED: For Question Based Response and Email Writing, send and store plain text/object
          payload = {
            questionId,
            assessment_assigned_id,
            timeTaken,
            answer: answer, // Send the answer directly to backend
          }
          answerForRedux = answer; // Store plain answer in Redux (no wrapper)
        } else {
          // For other responses without subQuestionId
          payload = {
            questionId,
            assessment_assigned_id,
            timeTaken,
            answer: answer,
          }
          answerForRedux = answer;
        }

        console.log('🔍 [ACTION] Saving response with payload:', payload)
        console.log('🔍 [ACTION] Question Type:', questionType)
        console.log('🔍 [ACTION] Has SubQuestion ID:', !!subQuestionId)
        console.log('🔍 [ACTION] Answer for Redux:', answerForRedux)

        const res = await studentRequest.post(
          'students/assessments/saveResponse',
          {
            payload,
          }
        )

        console.log('✅ [ACTION] Response saved successfully:', res.data)

        // FIXED: Dispatch with the plain answer for Redux storage
        dispatch({
          type: ASSESSMENT_TYPES.SAVE_RESPONSE_SUCCESS,
          payload: { questionId, answer: answerForRedux }, // Use answerForRedux instead of answer
          subQuestionId,
          questionType,
        })

        return res.data
      } catch (error) {
        dispatch({
          type: ASSESSMENT_TYPES.SAVE_RESPONSE_FAILURE,
          payload: error.message,
        })
        console.error('Error saving response:', error)
        throw error
      }
    }

export const fetchActiveAssessments =
  (studentId, filters) => async (dispatch, getState) => {
    dispatch(fetchActiveAssessmentsRequest())
    try {
      const queryParams = new URLSearchParams({
        duration: filters?.duration || '',
        assessmentType: filters?.assessmentType || '',
        search: filters?.search || '',
        excludePractice: 'true',
      }).toString()

      const res = await studentRequest.get(
        `students/getActiveAssessments/${studentId}?${queryParams}`
      )

      console.log('Active assessments response:', res?.data?.data)

      const assessmentsData =
        res?.data?.data?.assessments || res?.data?.data || []
      console.log('Active assessments processed data:', assessmentsData)

      dispatch(fetchActiveAssessmentsSuccess(assessmentsData))

      setTimeout(() => {
        const currentState = getState()
        console.log(
          '🔍 ACTIVE ASSESSMENTS STATE AFTER DISPATCH:',
          currentState.assessment?.activeAssessments
        )
      }, 100)
    } catch (error) {
      dispatch(fetchActiveAssessmentsFailure(error))
    }
  }

export const fetchCompletedAssessments =
  (studentId, filters) => async (dispatch, getState) => {
    dispatch(fetchCompletedAssessmentsRequest())
    try {
      const queryParams = new URLSearchParams({
        timeFilter: filters?.timeFilter || '',
        assessmentType: filters?.assessmentType || '',
        search: filters?.search || '',
        isPractice: 'false',
      }).toString()

      const res = await studentRequest.get(
        `students/getCompletedAssessment/${studentId}?${queryParams}`
      )

      console.log('Completed assessments response:', res?.data?.data)

      const assessmentsData =
        res?.data?.data?.assessments || res?.data?.data || []
      console.log('Completed assessments processed data:', assessmentsData)
      console.log('🔍 DISPATCHING COMPLETED ASSESSMENTS:', {
        type: 'FETCH_COMPLETED_ASSESSMENTS_SUCCESS',
        payload: assessmentsData,
        dataLength: assessmentsData.length,
        sampleData: assessmentsData[0] || 'No data',
      })

      dispatch(fetchCompletedAssessmentsSuccess(assessmentsData))

      setTimeout(() => {
        const currentState = getState()
        console.log('✅ Completed assessments dispatch completed')
        console.log('🔍 CURRENT REDUX STATE AFTER DISPATCH:')
        console.log(
          '   - Completed assessments state:',
          currentState.assessment?.completedAssessments
        )
      }, 100)
    } catch (error) {
      console.error('❌ Error fetching completed assessments:', error)
      dispatch(fetchCompletedAssessmentsFailure(error))
    }
  }

export const saveAssessmentResponse = (questionId, answer) => ({
  type: ASSESSMENT_TYPES.SAVE_ASSESSMENT_RESPONSE,
  payload: {
    questionId,
    answer,
  },
})

export const submitAssessment = payload => async (dispatch, getState) => {
  try {
    console.log('🔍 [ACTION] submitAssessment called with payload:', payload)

    dispatch({ type: ASSESSMENT_TYPES.SUBMIT_ASSESSMENT_REQUEST })

    const state = getState()
    const { assessment } = state
    const { currentAssessment } = assessment

    // If no payload provided, construct it from current assessment state
    if (!payload) {
      if (!currentAssessment || !currentAssessment.assessment_assigned_id) {
        throw new Error('No active assessment found for submission')
      }
      payload = {
        response: currentAssessment.responses || {},
        assessment_assigned_id: currentAssessment.assessment_assigned_id,
        full_name: null,
        totalTakenTime: 0,
      }
    }

    const getStudentName = () => {
      const studentData =
        state.studentData?.studentDetails ||
        state.auth?.user ||
        state.student ||
        state.user ||
        null

      if (!studentData) return 'Unknown Student'

      return (
        studentData.full_name ||
        studentData.fullName ||
        studentData.firstName ||
        studentData.name ||
        (studentData.firstName && studentData.lastName
          ? `${studentData.firstName} ${studentData.lastName}`
          : '') ||
        'Unknown Student'
      )
    }

    // --- Ensure all communication sections are present in the payload ---
    // This ensures the backend receives all sections, even if some are empty arrays.
    const commSections = [
      'paragraphReading',
      'audioQuestion',
      'videoResponse',
      'questionBasedResponse',
      'emailWriting',
      'dictation',
      'sentenceCompletion',
      'sentenceBuild'
    ];
    let responseData = payload.response || payload.responses || currentAssessment?.responses || {};
    const assessmentType = currentAssessment?.type?.toLowerCase() || 'unknown';

    if (assessmentType === 'communication') {
      commSections.forEach(section => {
        if (!responseData[section]) responseData[section] = [];
      });
    }

    // --- IMPORTANT: The video and audio URLs are already in the responses structure ---
    // Based on your reducer, the data is already properly structured in:
    // - responseData.videoResponse (contains videoFileUrl and objectKey)
    // - responseData.paragraphReading (contains audioUrl and objectKey)

    console.log('🔍 [ACTION] Current response data structure:', responseData)
    console.log('🔍 [ACTION] Assessment type:', assessmentType)
    console.log('🔍 [ACTION] Video responses:', responseData.videoResponse)
    console.log('🔍 [ACTION] Paragraph reading with audio:', responseData.paragraphReading)

    const submissionData = {
      response: responseData,
      assessment_assigned_id: payload.assessment_assigned_id || currentAssessment?.assessment_assigned_id,
      full_name: payload.full_name || getStudentName(),
      totalTakenTime: payload.totalTakenTime || 0,
    };

    // Validate required fields
    if (!submissionData.assessment_assigned_id) {
      throw new Error('Assessment assigned ID is required for submission')
    }

    console.log('🔍 [ACTION] Sending submission data:', submissionData)
    console.log('🔍 [ACTION] Student name resolved as:', submissionData.full_name)

    // Enhanced logging for media URLs
    if (responseData.videoResponse && responseData.videoResponse.length > 0) {
      console.log('🎥 [ACTION] Video URLs being submitted:', responseData.videoResponse.map(v => ({
        questionId: v.questionId,
        videoFileUrl: v.videoFileUrl,
        objectKey: v.objectKey
      })))
    }

    if (responseData.paragraphReading && responseData.paragraphReading.length > 0) {
      console.log('🎵 [ACTION] Audio URLs being submitted:', responseData.paragraphReading.map(p => ({
        questionId: p.questionId,
        audioUrl: p.audioUrl,
        objectKey: p.objectKey
      })))
    }

    const response = await studentRequest.post('/students/submitAssessment', submissionData)

    console.log('🔍 [ACTION] Backend response:', response.data)

    if (response.data?.message === 'success' || response.status === 200) {
      dispatch({
        type: ASSESSMENT_TYPES.SUBMIT_ASSESSMENT_SUCCESS,
        payload: response.data?.data || response.data,
      })

      const assessmentAssignedId = submissionData.assessment_assigned_id
      if (assessmentAssignedId) {
        // Attempt is finished — drop the same-browser in-progress marker.
        clearAssessmentMarker(assessmentAssignedId)
        // FIXED: Only trigger score calculation for aptitude assessments
        // Role-based and communication assessments will be calculated by cron job
        if (assessmentType === 'aptitude') {
          console.log('🔄 [BACKGROUND] Triggering aptitude score calculation for:', assessmentAssignedId)
          studentRequest
            .post(`/students/assessments/calculateAptitudeScore`, {
              assessmentAssignedId: assessmentAssignedId,
            })
            .then(scoreResponse => {
              console.log('✅ [BACKGROUND] Aptitude score calculation completed:', scoreResponse.data)
            })
            .catch(scoreError => {
              console.warn('⚠️ [BACKGROUND] Aptitude score calculation failed (non-critical):', scoreError.message)
            })
        } else if (assessmentType === 'communication') {
          console.log('📝 [INFO] Communication assessment submitted - score will be calculated by cron job')
          // Do NOT trigger any score calculation here for communication
        } else if (assessmentType === 'role-based' || assessmentType === 'role_based') {
          console.log('🎭 [INFO] Role-based assessment submitted - score will be calculated by cron job')
          // Do NOT trigger any score calculation here for role-based
        } else {
          console.log('❓ [INFO] Unknown assessment type:', assessmentType, '- no immediate score calculation')
          // For unknown types, don't trigger any calculation
        }
      }

      return response.data
    } else {
      throw new Error(response.data?.error || 'Submission failed')
    }
  } catch (error) {
    console.error('❌ [ACTION] submitAssessment error:', error)
    dispatch({
      type: ASSESSMENT_TYPES.SUBMIT_ASSESSMENT_FAILURE,
      payload: error.message,
    })
    throw error
  }
}


export const fetchReports =
  (assessmentAssignedIds = []) =>
    async (dispatch, getState) => {
      try {
        console.log('🔍 FETCH REPORTS START')
        dispatch(fetchReportsRequest())

        const state = getState()
        const studentId = state.auth?.studentId

        console.log('🔍 FETCH REPORTS - Student ID:', studentId)
        console.log(
          '🔍 FETCH REPORTS - Current completed assessments state:',
          state.assessment?.completedAssessments
        )

        if (!studentId) {
          throw new Error('Student ID not found')
        }

        let idsToFetch = assessmentAssignedIds

        if (!idsToFetch || idsToFetch.length === 0) {
          const completedAssessments =
            state.assessment?.completedAssessments?.data ||
            state.assessment?.completedAssessments ||
            []
          console.log(
            '🔍 FETCH REPORTS - Using completed assessments from state:',
            completedAssessments
          )
          idsToFetch = completedAssessments
            .map(assessment => assessment.assessment_assigned_id)
            .filter(id => id)
          console.log('🔍 FETCH REPORTS - Assessment IDs to fetch:', idsToFetch)
        }

        if (idsToFetch.length === 0) {
          console.log(
            '🔍 FETCH REPORTS - No assessment IDs found, dispatching empty array'
          )
          dispatch(fetchReportsSuccess([]))
          return []
        }

        const payload = {
          assessment_assigned_ids: idsToFetch,
          student_id: studentId,
        }

        console.log('🔍 FETCH REPORTS - API payload:', payload)

        const response = await studentRequest.post(
          'students/getAssessmentReport',
          payload
        )

        console.log('🔍 FETCH REPORTS - API response:', response.data)

        if (response.data && response.data.message === 'success') {
          const reportsData = response.data.data || []
          console.log(
            '🔍 FETCH REPORTS - Success, dispatching reports:',
            reportsData.length,
            'reports'
          )
          dispatch(fetchReportsSuccess(reportsData))
          return reportsData
        } else {
          throw new Error(response.data?.message || 'Failed to fetch reports')
        }
      } catch (error) {
        console.error('❌ FETCH REPORTS ERROR:', error)
        dispatch(fetchReportsFailure(error.message))
        throw error
      }
    }

export const generatePDFReport =
  assessment_assigned_id => async (dispatch, getState) => {
    try {
      console.log("=== FRONTEND PDF GENERATION DEBUG ===");
      console.log("Input assessment_assigned_id:", assessment_assigned_id);

      const state = getState()
      console.log("Full Redux state structure:", {
        hasStudentData: !!state.studentData,
        hasAssessment: !!state.assessment,
        assessmentKeys: state.assessment ? Object.keys(state.assessment) : 'NO ASSESSMENT STATE'
      });

      // Let's check all possible paths for completed assessments
      const possiblePaths = [
        state.assessment?.completedAssessments?.data?.assessments,
        state.assessment?.completedAssessments?.assessments,
        state.assessment?.completedAssessments?.data,
        state.assessment?.completedAssessments,
        state.assessment?.reports?.data,
        state.assessment?.reports,
      ];

      console.log("Checking possible assessment data paths:");
      possiblePaths.forEach((path, index) => {
        console.log(`Path ${index}:`, path ?
          (Array.isArray(path) ? `Array with ${path.length} items` : `Object with keys: ${Object.keys(path)}`) :
          'null/undefined'
        );
      });

      // Try to find the assessments array
      let completedAssessments = null;
      for (const path of possiblePaths) {
        if (Array.isArray(path)) {
          completedAssessments = path;
          break;
        }
      }

      if (!completedAssessments) {
        console.log("Full assessment state structure:", JSON.stringify(state.assessment, null, 2));
        throw new Error("Could not find completed assessments in Redux state");
      }

      console.log("Found completed assessments:", completedAssessments.length, "items");
      console.log("Assessment IDs available:", completedAssessments.map(a => ({
        id: a.id,
        assessment_assigned_id: a.assessment_assigned_id,
        title: a.title,
        type: a.type
      })));

      console.log("Looking for assessment with ID:", assessment_assigned_id);

      // Try multiple ways to find the assessment
      let matchingAssessment = null;

      // Method 1: Find by id (what we tried before)
      matchingAssessment = completedAssessments.find(
        assessment => assessment.id === assessment_assigned_id
      );

      if (!matchingAssessment) {
        // Method 2: Find by assessment_assigned_id (in case the frontend is already passing the correct ID)
        matchingAssessment = completedAssessments.find(
          assessment => assessment.assessment_assigned_id === assessment_assigned_id
        );
      }

      console.log("Matching assessment found:", matchingAssessment);

      if (!matchingAssessment) {
        // Let's try a more flexible search
        const partialMatches = completedAssessments.filter(assessment =>
          assessment.id?.includes(assessment_assigned_id.substring(0, 8)) ||
          assessment.assessment_assigned_id?.includes(assessment_assigned_id.substring(0, 8))
        );

        console.log("Partial matches found:", partialMatches);

        throw new Error(`Assessment not found with ID: ${assessment_assigned_id}. Available IDs: ${completedAssessments.map(a => a.id).join(', ')}`);
      }

      const student_id = state?.studentData?.studentDetails?.id
      const studentName = state?.studentData?.studentDetails?.fullName || 'Student'

      console.log("Extracted student data:", {
        student_id,
        studentName
      });

      if (!student_id) {
        throw new Error("Student ID not found in state");
      }

      // Determine which ID to use for the API call
      const correctAssessmentAssignedId = matchingAssessment.assessment_assigned_id || matchingAssessment.id;

      if (!correctAssessmentAssignedId) {
        throw new Error(`No valid assessment_assigned_id found in assessment: ${JSON.stringify(matchingAssessment)}`);
      }

      const requestPayload = {
        assessment_assigned_id: correctAssessmentAssignedId,
        student_id,
      };

      console.log("API request payload:", requestPayload);

      dispatch(generatePDFReportRequest())

      const response = await studentRequest.post(
        `/students/assessments/generatePDFReport`,
        requestPayload,
        {
          responseType: 'blob',
          headers: {
            Accept: 'application/pdf',
          },
        }
      )

      console.log("API response received:", {
        status: response.status,
        dataSize: response.data?.size
      });

      console.log("Response headers:", JSON.stringify(response.headers, null, 2));

      // Get filename from Content-Disposition header
      const contentDisposition = response.headers['content-disposition']
      let fileName = 'assessment_report.pdf' // default fallback
      console.log("Content-Disposition header:", contentDisposition);
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename=(.+)/)
        if (filenameMatch && filenameMatch[1]) {
          fileName = filenameMatch[1].trim()
        }
      }

      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()

      setTimeout(() => {
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      }, 100)

      dispatch(generatePDFReportSuccess({ fileName }))
      return { success: true, fileName }
    } catch (error) {
      console.error('=== FRONTEND PDF GENERATION ERROR ===');
      console.error('Error details:', error);
      console.error('Error response:', error.response?.data);

      // If it's a blob error, try to read it as text
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          console.error('Error blob content:', text);
        } catch (blobError) {
          console.error('Could not read blob error:', blobError);
        }
      }

      dispatch(generatePDFReportFailure(error.message))
      throw error
    }
  }

export const submitPracticeAssessment =
  (isPractice = false) =>
    async (dispatch, getState) => {
      try {
        const state = getState()
        const fullName = state?.studentData?.studentDetails?.fullName
        const { assessment } = state
        const { currentAssessment } = assessment

        if (!currentAssessment || !currentAssessment.assessment_assigned_id) {
          throw new Error('No active practice assessment found')
        }

        const responses = currentAssessment.responses || {}

        const payload = {
          assessment_assigned_id: currentAssessment.assessment_assigned_id,
          response: responses,
          full_name: fullName,
          isPractice: true,
        }

        const response = await studentRequest.post(
          '/students/submitAssessment',
          payload
        )

        if (response.status === 200) {
          if (isPractice) {
            localStorage.removeItem('isPracticeAssessment')
          }

          dispatch({
            type: ASSESSMENT_TYPES.SUBMIT_ASSESSMENT_SUCCESS,
            payload: {
              data: response.data,
              isPractice: isPractice,
            },
          })

          const studentId = state?.studentData?.studentDetails?.id
          if (studentId) {
            dispatch(fetchCompletedPracticeAssessments(studentId))
          }

          return response.data
        } else {
          dispatch({
            type: ASSESSMENT_TYPES.SUBMIT_ASSESSMENT_FAILURE,
            payload: {
              error: 'Failed to submit assessment',
            },
          })
          return null
        }
      } catch (error) {
        console.error('Error submitting assessment:', error)
        dispatch({
          type: ASSESSMENT_TYPES.SUBMIT_ASSESSMENT_FAILURE,
          payload: {
            error: error.message || 'Unknown error occurred',
          },
        })
        return null
      }
    }

export const fetchCompletedPracticeAssessments =
  (studentId, page = 1, limit = 5, assessmentType = null) =>
    async dispatch => {
      try {
        console.log('FetchCompletedPracticeAssessments called with pagination', {
          studentId,
          page,
          limit,
          assessmentType,
        })

        dispatch(fetchCompletedPracticeAssessmentsRequest())

        // ALSO dispatch practice history request for type-specific calls
        if (assessmentType) {
          dispatch(fetchPracticeHistoryRequest())
        }

        if (!assessmentType) {
          // If no specific assessment type, fetch all practice assessments
          console.log(
            '🔍 No assessment type specified, fetching all practice assessments'
          )

          const apiUrl = `students/getCompletedAssessment/${studentId}?timeFilter=&assessmentType=&search=&isPractice=true&page=${page}&limit=${limit}`

          console.log('🔍 API URL:', apiUrl)

          const response = await studentRequest.get(apiUrl)

          const allPracticeAssessments = response.data?.data?.assessments || []

          // Sort by submission date
          allPracticeAssessments.sort(
            (a, b) => new Date(b.submittedAt) - new Date(a.submittedAt)
          )

          const payload = {
            assessments: allPracticeAssessments,
            pagination: response.data?.data?.pagination || {
              currentPage: page,
              totalCount: allPracticeAssessments.length,
              limit: limit,
            },
          }

          dispatch(fetchCompletedPracticeAssessmentsSuccess(payload))
          return payload
        }

        // For specific assessment types
        let apiUrl = `students/getCompletedAssessment/${studentId}?timeFilter=&assessmentType=${assessmentType}&search=&isPractice=true&page=${page}&limit=${limit}`

        const response = await studentRequest.get(apiUrl)

        console.log('Completed practice assessments response:', response.data)

        if (response.data && response.data.message === 'success') {
          const practiceData = response.data.data
          const allPracticeAssessments = practiceData.assessments || []

          console.log('All practice assessments:', allPracticeAssessments)

          const filteredAssessments = assessmentType
            ? allPracticeAssessments.filter(assessment => {
              const type = assessment.type || assessment.assessmentType || ''
              return type.toLowerCase() === assessmentType.toLowerCase()
            })
            : allPracticeAssessments

          filteredAssessments.sort(
            (a, b) => new Date(b.submittedAt) - new Date(a.submittedAt)
          )

          const payload = {
            assessments: filteredAssessments,
            pagination: practiceData.pagination,
            assessmentType: assessmentType,
          }

          // FIXED: Dispatch both actions for type-specific requests
          if (assessmentType) {
            // Dispatch to practiceAssessments.history for type-specific selectors
            dispatch(fetchPracticeHistorySuccess(payload))

            // ALSO dispatch to completedPracticeAssessments for consistency
            dispatch(fetchCompletedPracticeAssessmentsSuccess(payload))
          } else {
            dispatch(fetchCompletedPracticeAssessmentsSuccess(payload))
          }

          return payload
        } else {
          throw new Error('Invalid response format')
        }
      } catch (error) {
        console.error('Error fetching completed practice assessments:', error)

        if (assessmentType) {
          dispatch(fetchPracticeHistoryFailure(error.message))
        }
        dispatch(fetchCompletedPracticeAssessmentsFailure(error.message))
        throw error
      }
    }

// Also update these convenience functions:
export const fetchCommunicationPracticeAssessments = (
  studentId,
  page = 1,
  limit = 5
) => {
  return fetchCompletedPracticeAssessments(
    studentId,
    page,
    limit,
    'Communication'
  ) // Capitalized
}

export const fetchAptitudePracticeAssessments = (
  studentId,
  page = 1,
  limit = 5
) => {
  return fetchCompletedPracticeAssessments(studentId, page, limit, 'Aptitude') // Capitalized
}

export const uploadVideoResponse = (videoBlob, questionId, assessmentAssignedId) => {
  return (dispatch, getState) => {
    console.log('🎥 [ACTION] Uploading video in background...')

    const state = getState()
    const formData = new FormData()
    const studentDetails = state?.studentData?.studentDetails

    // Get assessmentAssignedId from state if not provided
    const actualAssessmentAssignedId = assessmentAssignedId ||
      state?.assessment?.assessmentData?.assessmentAssignedId ||
      state?.assessment?.currentAssessmentId

    const studentIdForFilename = studentDetails?.id || 'unknown_student'
    const baseFilename = `Video_response_${studentIdForFilename}-${Date.now()}`

    // IMPORTANT: Append fields BEFORE file for Fastify multipart to read them
    if (actualAssessmentAssignedId) {
      formData.append('assessmentAssignedId', actualAssessmentAssignedId)
    }
    if (questionId) {
      formData.append('questionId', questionId)
    }

    // Append video file LAST
    formData.append('video', videoBlob, filenameForMimeType(baseFilename, videoBlob && videoBlob.type))

    console.log(' [ACTION] FormData prepared:', {
      filename: filenameForMimeType(baseFilename, videoBlob && videoBlob.type),
      assessmentAssignedId: actualAssessmentAssignedId,
      questionId: questionId,
      blobSize: videoBlob.size
    })

    // Return a Promise that resolves AFTER the HTTP upload settles, so
    // callers that need to wait (e.g. handleSubmit on auto-submit) can
    // await it. Callers that don't care can ignore the Promise — they
    // continue to behave as fire-and-forget, since we never throw.
    return studentRequest.post(
      'students/assessments/uploadVideo',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
      .then(res => {
        console.log(' [ACTION] Upload response from server:', res.data)

        let videoKey = filenameForMimeType(baseFilename, videoBlob && videoBlob.type)

        if (res.data && res.data.data && res.data.data.parUrl) {
          const { parUrl, storedInDb } = res.data.data

          if (parUrl.includes('/')) {
            const parts = parUrl.split('/')
            videoKey = parts[parts.length - 1]
            if (videoKey.includes('?')) {
              videoKey = videoKey.split('?')[0]
            }
            try {
              videoKey = decodeURIComponent(videoKey)
            } catch (e) {
              // ignore
            }
          }

          console.log(' [VIDEO_UPLOAD] Video uploaded successfully:', { parUrl, storedInDb })

          // Store in Redux state when upload completes
          dispatch({
            type: ASSESSMENT_TYPES.STORE_VIDEO_RESPONSE,
            payload: {
              questionId,
              parUrl,
              baseFilename: videoKey,
            },
          })

          // Mark as uploaded in sessionStorage
          sessionStorage.setItem('assessment_video_uploaded', 'true')
        }

        return videoKey
      })
      .catch(error => {
        console.error(' [VIDEO_UPLOAD] Error uploading video:', error)
        dispatch({
          type: ASSESSMENT_TYPES.STORE_VIDEO_RESPONSE,
          payload: {
            questionId,
            parUrl: '',
            baseFilename: '',
          },
        })
        return null
      })
  }
}

export const uploadAudioResponse =
  (audioBlob, questionId, assessmentAssignedId) => (dispatch, getState) => {
    console.log(' [ACTION] Uploading audio in background...')

    const state = getState()
    const formData = new FormData()
    const studentDetails = state?.studentData?.studentDetails

    // Get assessmentAssignedId from state if not provided
    const actualAssessmentAssignedId = assessmentAssignedId ||
      state?.assessment?.assessmentData?.assessmentAssignedId ||
      state?.assessment?.currentAssessmentId

    const studentIdForFilename = studentDetails?.id || 'unknown_student'
    const baseFilename = `Paragraph_reading_${studentIdForFilename}-${Date.now()}`

    // IMPORTANT: Append fields BEFORE file for Fastify multipart to read them
    if (actualAssessmentAssignedId) {
      formData.append('assessmentAssignedId', actualAssessmentAssignedId)
    }
    if (questionId) {
      formData.append('questionId', questionId)
    }

    // Append audio file LAST
    formData.append('audio', audioBlob, filenameForMimeType(baseFilename, audioBlob && audioBlob.type))

    console.log('🎵 [ACTION] FormData prepared:', {
      filename: filenameForMimeType(baseFilename, audioBlob && audioBlob.type),
      assessmentAssignedId: actualAssessmentAssignedId,
      questionId: questionId,
      blobSize: audioBlob.size
    })

    // Return a Promise that resolves AFTER the HTTP upload settles, so
    // callers that need to wait (e.g. handleSubmit on auto-submit) can
    // await it. Callers that don't care can ignore the Promise — they
    // continue to behave as fire-and-forget, since we never throw.
    return studentRequest.post(
      'students/assessments/uploadAudio',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
      .then(res => {
        console.log('🎵 [ACTION] Upload response from server:', res.data)

        if (res.data && res.data.data && res.data.data.parUrl) {
          const { parUrl, storedInDb } = res.data.data

          console.log('✅ [AUDIO_UPLOAD] Audio uploaded successfully:', { parUrl, storedInDb })

          dispatch({
            type: ASSESSMENT_TYPES.STORE_AUDIO_RESPONSE,
            payload: {
              questionId,
              parUrl,
              baseFilename: filenameForMimeType(baseFilename, audioBlob && audioBlob.type),
            },
          })

          // Mark as uploaded in sessionStorage
          sessionStorage.setItem('assessment_audio_uploaded', 'true')
        }

        return filenameForMimeType(baseFilename, audioBlob && audioBlob.type)
      })
      .catch(error => {
        console.error('❌ [AUDIO_UPLOAD] Error uploading audio:', error)
        dispatch({
          type: ASSESSMENT_TYPES.STORE_AUDIO_RESPONSE,
          payload: {
            questionId,
            parUrl: '',
            baseFilename: '',
          },
        })
        return null
      })
  }


export const uploadProctorScreenshot =
  (imageData, assessmentId) => async (dispatch, getState) => {
    try {
      const { studentData } = getState()
      const { studentDetails } = studentData

      const payload = {
        image: imageData,
        assessmentAssignedId: assessmentId,
        studentId: studentDetails.id,
        ipAddress: window.location.hostname,
      }

      const response = await studentRequest.post(
        'students/assessment/storeProctorImage',
        payload
      )

      return { success: true }
    } catch (error) {
      console.error('Error uploading proctoring image:', error)
      return { success: false }
    }
  }

export const checkRetakeEligibility =
  assessmentAssignedId => async dispatch => {
    try {
      console.log('🔄 CHECKING RETAKE ELIGIBILITY START')
      console.log('   - Assessment Assigned ID:', assessmentAssignedId)
      dispatch(checkRetakeEligibilityRequest())

      const response = await studentRequest.get(
        `retake-eligibility/${assessmentAssignedId}`
      )

      console.log('✅ RETAKE ELIGIBILITY RESPONSE:', response.data)

      if (response.data && response.data.message === 'success') {
        const eligibilityData = response.data.data
        console.log('   - Can Retake:', eligibilityData.canRetake)
        console.log('   - Reason:', eligibilityData.reason)
        console.log('   - Assessment Type:', eligibilityData.assessmentType)

        dispatch(
          checkRetakeEligibilitySuccess({
            assessmentAssignedId,
            ...eligibilityData,
          })
        )

        return eligibilityData
      } else {
        throw new Error('Invalid response format')
      }
    } catch (error) {
      console.error('❌ RETAKE ELIGIBILITY ERROR:', error)
      console.error('   - Error message:', error.message)
      console.error('   - Error response:', error.response?.data)

      const errorMessage = error.response?.data?.message || error.message
      dispatch(checkRetakeEligibilityFailure(errorMessage))

      return {
        canRetake: false,
        reason: 'Error checking eligibility',
        assessmentType: 'communication',
      }
    }
  }

export const fetchSolutionsRequest = () => ({
  type: ASSESSMENT_TYPES.FETCH_SOLUTIONS_REQUEST,
})

export const fetchSolutionsSuccess = data => ({
  type: ASSESSMENT_TYPES.FETCH_SOLUTIONS_SUCCESS,
  payload: data,
})

export const fetchSolutionsFailure = error => ({
  type: ASSESSMENT_TYPES.FETCH_SOLUTIONS_FAILURE,
  payload: error,
})

export const fetchAssessmentSolutions =
  assessmentAssignedId => async dispatch => {
    try {
      console.log(
        '🔍 [ACTION] fetchAssessmentSolutions called with ID:',
        assessmentAssignedId
      )

      dispatch(fetchSolutionsRequest())

      const response = await studentRequest.get(
        `/students/assessments/result-info?assessmentAssignedId=${assessmentAssignedId}`
      )

      console.log('🔍 [ACTION] Solutions response:', response.data)

      if (response.data?.message === 'success') {
        dispatch(fetchSolutionsSuccess(response.data.data))
        return response.data.data
      } else {
        throw new Error(response.data?.error || 'Failed to fetch solutions')
      }
    } catch (error) {
      console.error('❌ [ACTION] fetchAssessmentSolutions error:', error)
      dispatch(fetchSolutionsFailure(error.message))
      throw error
    }
  }

export const fetchAptitudeScoreRequest = () => ({
  type: ASSESSMENT_TYPES.FETCH_APTITUDE_SCORE_REQUEST,
})

export const fetchAptitudeScoreSuccess = data => ({
  type: ASSESSMENT_TYPES.FETCH_APTITUDE_SCORE_SUCCESS,
  payload: data,
})

export const fetchAptitudeScoreFailure = error => ({
  type: ASSESSMENT_TYPES.FETCH_APTITUDE_SCORE_FAILURE,
  payload: error,
})

export const fetchAptitudeScore = assessmentAssignedId => async dispatch => {
  try {
    console.log(
      '🔍 [ACTION] fetchAptitudeScore called with ID:',
      assessmentAssignedId
    )

    dispatch(fetchAptitudeScoreRequest())

    const response = await studentRequest.get(
      `/students/assessments/getAptitudeScore?assessmentAssignedId=${assessmentAssignedId}`
    )

    console.log('🔍 [ACTION] Aptitude score response:', response.data)

    if (response.data?.message === 'success') {
      dispatch(fetchAptitudeScoreSuccess(response.data.data))
      return response.data.data
    } else {
      throw new Error(response.data?.error || 'Failed to fetch aptitude score')
    }
  } catch (error) {
    console.error('❌ [ACTION] fetchAptitudeScore error:', error)
    dispatch(fetchAptitudeScoreFailure(error.message))
    throw error
  }
}

export const fetchActivityMap = (
  primaryEmail,
  isPractice = true,
  startDate,
  endDate
) => {
  return async dispatch => {
    dispatch(fetchActivityMapRequest())

    try {
      const params = new URLSearchParams({
        primaryEmail: primaryEmail,
        is_practice: isPractice.toString(),
        startDate: startDate,
        endDate: endDate,
      })

      const response = await studentRequest.get(
        `students/getActivityMap?${params}`
      )

      if (response.data && response.data.message === 'success') {
        dispatch(fetchActivityMapSuccess(response.data.data))
      } else {
        dispatch(fetchActivityMapFailure('Failed to fetch activity data'))
      }
    } catch (error) {
      dispatch(
        fetchActivityMapFailure(
          error.message || 'An error occurred while fetching activity data'
        )
      )
    }
  }
}
export const checkPracticeAccessRequest = () => ({
  type: ASSESSMENT_TYPES.CHECK_PRACTICE_ACCESS_REQUEST,
})

export const checkPracticeAccessSuccess = data => ({
  type: ASSESSMENT_TYPES.CHECK_PRACTICE_ACCESS_SUCCESS,
  payload: data,
})

export const checkPracticeAccessFailure = error => ({
  type: ASSESSMENT_TYPES.CHECK_PRACTICE_ACCESS_FAILURE,
  payload: error,
})

// Update the checkPracticeAccess function around line 1050:

export const checkPracticeAccess =
  (studentId, assessmentTypes = ['Communication', 'Aptitude']) =>
    async (dispatch, getState) => {
      try {
        const state = getState()
        const actualStudentId = state.auth?.studentId

        console.log('🔄 Checking practice access for student:', actualStudentId)

        dispatch(checkPracticeAccessRequest())

        // Practice opens per type when the institute has that type marked
        // Unlimited in Feature Access (resolved server-side).
        const response = await studentRequest.get(
          `students/practice-access/${actualStudentId}`
        )
        if (response.data?.message !== 'success') {
          throw new Error(response.data?.error || 'Invalid practice access response')
        }
        const serverAccess = response.data.data || {}

        const accessState = {
          hasAccess: false,
          loading: false,
          error: null,
        }

        assessmentTypes.forEach(assessmentType => {
          const typeAccess = serverAccess[assessmentType] || {}
          accessState[assessmentType] = {
            hasAccess: Boolean(typeAccess.hasAccess),
            reason: typeAccess.reason || `${assessmentType} practice is not enabled for your institute`,
            loading: false,
            error: null,
          }
          if (typeAccess.hasAccess) {
            accessState.hasAccess = true
          }
        })

        console.log('✅ Practice access check complete:', {
          Communication: accessState.Communication?.hasAccess
            ? 'UNLOCKED'
            : 'LOCKED',
          Aptitude: accessState.Aptitude?.hasAccess ? 'UNLOCKED' : 'LOCKED',
        })

        // ADD DETAILED LOGGING BEFORE DISPATCH
        console.log(
          '🔍 ACTION: About to dispatch success with payload:',
          accessState
        )
        console.log(
          '🔍 ACTION: Communication access state:',
          accessState.Communication
        )
        console.log('🔍 ACTION: Aptitude access state:', accessState.Aptitude)

        dispatch(checkPracticeAccessSuccess(accessState))

        // ADD VERIFICATION AFTER DISPATCH
        setTimeout(() => {
          const newState = getState()
          console.log(
            '🔍 ACTION: State after dispatch:',
            newState.assessment?.practiceAccess
          )
          console.log(
            '🔍 ACTION: Communication in state:',
            newState.assessment?.practiceAccess?.Communication
          )
          console.log(
            '🔍 ACTION: Aptitude in state:',
            newState.assessment?.practiceAccess?.Aptitude
          )
        }, 100)

        return accessState
      } catch (error) {
        console.error('❌ Practice access check failed:', error.message)

        const errorState = {
          hasAccess: false,
          loading: false,
          error: error.message,
          Communication: {
            hasAccess: false,
            loading: false,
            error: error.message,
            reason: 'Error checking access',
          },
          Aptitude: {
            hasAccess: false,
            loading: false,
            error: error.message,
            reason: 'Error checking access',
          },
        }

        dispatch(checkPracticeAccessFailure(errorState))
        return errorState
      }
    }

// Convenience methods for checking specific types
export const checkCommunicationPracticeAccess = studentId => async dispatch => {
  return checkPracticeAccess(studentId, 'Communication')(dispatch) // Changed from 'communication' to 'Communication'
}

export const checkAptitudePracticeAccess = studentId => async dispatch => {
  return checkPracticeAccess(studentId, 'Aptitude')(dispatch) // Changed from 'aptitude' to 'Aptitude'
}

export const fetchPracticeScores = email => async dispatch => {
  try {
    dispatch({ type: ASSESSMENT_TYPES.FETCH_PRACTICE_SCORES_REQUEST })

    const response = await studentRequest.get(
      `students/practice-scores/${encodeURIComponent(email)}`
    )
    const result = response.data

    console.log('Practice scores response:', result)

    if (result.message === 'success') {
      // Handle empty object response by converting to empty array
      let practiceData = result.data
      if (!practiceData || (typeof practiceData === 'object' && !Array.isArray(practiceData) && Object.keys(practiceData).length === 0)) {
        practiceData = []
      } else if (!Array.isArray(practiceData)) {
        console.warn('Practice scores data is not an array, converting to array')
        practiceData = []
      }

      // Extract dayZero data if available (Communication uses "dataZero" key)
      const dayZero = result.dataZero || result.dayZero || null

      console.log('🔍 Communication dayZero data:', dayZero)

      const payload = {
        data: practiceData,
        dayZero: dayZero
      }

      dispatch({
        type: ASSESSMENT_TYPES.FETCH_PRACTICE_SCORES_SUCCESS,
        payload: payload,
      })
      return payload
    } else {
      console.error(
        'Practice scores fetch failed:',
        result.error || 'Unknown error'
      )
      throw new Error(result.error || 'Failed to fetch practice scores')
    }
  } catch (error) {
    console.error('Practice scores exception:', error)
    dispatch({
      type: ASSESSMENT_TYPES.FETCH_PRACTICE_SCORES_FAILURE,
      payload: error.message,
    })
    return []
  }
}

export const fetchAptitudePracticeScores = email => async dispatch => {
  try {
    dispatch({ type: ASSESSMENT_TYPES.FETCH_APTITUDE_PRACTICE_SCORES_REQUEST })

    console.log('🔍 Fetching aptitude practice scores for:', email)

    const response = await studentRequest.get(
      `students/assessments/getAllAptitudeScoresOfStudent?primaryEmail=${encodeURIComponent(
        email
      )}`
    )
    const result = response.data

    console.log('🔍 Aptitude practice scores response:', result)

    if (result.message === 'success') {
      // Handle empty object response by converting to empty array
      let aptitudeData = result.data
      if (!aptitudeData || (typeof aptitudeData === 'object' && !Array.isArray(aptitudeData) && Object.keys(aptitudeData).length === 0)) {
        console.log('🔍 Aptitude data is empty object, converting to empty array')
        aptitudeData = []
      } else if (!Array.isArray(aptitudeData)) {
        console.warn('Aptitude practice scores data is not an array, converting to array')
        aptitudeData = []
      }

      // Extract dayZero data if available
      const dayZero = result.dayZero || null

      console.log('🔍 Aptitude dayZero data:', dayZero)

      const payload = {
        data: aptitudeData,
        dayZero: dayZero
      }

      dispatch({
        type: ASSESSMENT_TYPES.FETCH_APTITUDE_PRACTICE_SCORES_SUCCESS,
        payload: payload,
      })
      return payload
    } else {
      console.error(
        'Aptitude practice scores fetch failed:',
        result.error || 'Unknown error'
      )
      throw new Error(
        result.error || 'Failed to fetch aptitude practice scores'
      )
    }
  } catch (error) {
    console.error('Aptitude practice scores exception:', error)
    dispatch({
      type: ASSESSMENT_TYPES.FETCH_APTITUDE_PRACTICE_SCORES_FAILURE,
      payload: error.message,
    })
    return []
  }
}

export const fetchDropoutAssessments =
  (studentId, filters) => async dispatch => {
    console.log('🔄 Action: fetchDropoutAssessments called with:', {
      studentId,
      filters,
    })
    dispatch(fetchDropoutAssessmentsRequest())
    try {
      const queryParams = new URLSearchParams({
        timeFilter: filters?.timeFilter || '',
        assessmentType: filters?.assessmentType || '',
        search: filters?.search || '',
      }).toString()

      console.log(
        '🌐 API Call: Making request to:',
        `students/getDropoutAssessments/${studentId}?${queryParams}`
      )
      const res = await studentRequest.get(
        `students/getDropoutAssessments/${studentId}?${queryParams}`
      )
      console.log('✅ API Response:', res?.data)
      dispatch(fetchDropoutAssessmentsSuccess(res?.data))
      console.log(
        '✅ Action: fetchDropoutAssessmentsSuccess dispatched with:',
        res?.data
      )
    } catch (error) {
      console.log('❌ API Error:', error)
      dispatch(fetchDropoutAssessmentsFailure(error))
    }
  }

export const checkStudentCorporateStatus = (primaryEmail) => async dispatch => {
  try {
    console.log('🔄 Checking student corporate status for:', primaryEmail)
    dispatch(checkStudentCorporateStatusRequest())

    const response = await studentRequest.get(
      `students/isStudentOnlyCorporate?primaryEmail=${encodeURIComponent(primaryEmail)}`
    )

    console.log('✅ Corporate status API response:', response.data)

    if (response.data?.message === 'success') {
      dispatch(checkStudentCorporateStatusSuccess(response.data.data))
      return response.data.data
    } else {
      throw new Error('Failed to check corporate status')
    }
  } catch (error) {
    console.error('❌ Error checking corporate status:', error)
    dispatch(checkStudentCorporateStatusFailure(error.message))
    return { isCorporate: false }
  }
}

// Direct Assessment Action Creators
export const loadDirectAssessmentRequest = () => ({
  type: ASSESSMENT_TYPES.LOAD_DIRECT_ASSESSMENT_REQUEST,
})

export const loadDirectAssessmentSuccess = (assessment) => ({
  type: ASSESSMENT_TYPES.LOAD_DIRECT_ASSESSMENT_SUCCESS,
  payload: assessment,
})

export const loadDirectAssessmentFailure = (error) => ({
  type: ASSESSMENT_TYPES.LOAD_DIRECT_ASSESSMENT_FAILURE,
  payload: error,
})

// Direct Assessment Thunk Action
export const loadDirectAssessment = (studentId, assessment_assigned_id, assessment_set_id) => async (dispatch) => {
  try {
    console.log('🔄 Loading direct assessment...', { studentId, assessment_assigned_id, assessment_set_id })
    dispatch(loadDirectAssessmentRequest())

    // First, fetch active assessments to find the matching one
    const activeAssessmentsResponse = await studentRequest.get(
      `students/getActiveAssessments/${studentId}?duration=&assessmentType=&search=&excludePractice=true`
    )

    if (activeAssessmentsResponse.data?.message === 'success') {
      const assessments = activeAssessmentsResponse.data.data || []

      // Find the matching assessment
      const matchingAssessment = assessments.find(
        assessment =>
          assessment.assessment_assigned_id === assessment_assigned_id &&
          assessment.assessment_set_id === assessment_set_id
      )

      if (matchingAssessment) {
        console.log('✅ Found matching assessment for direct access:', matchingAssessment)
        dispatch(loadDirectAssessmentSuccess(matchingAssessment))
        return matchingAssessment
      } else {
        throw new Error('Assessment not found or not accessible')
      }
    } else {
      throw new Error('Failed to fetch assessments')
    }
  } catch (error) {
    console.error('❌ Error loading direct assessment:', error)
    dispatch(loadDirectAssessmentFailure(error.message))
    throw error
  }
}

// Behaviour specialisation actions
export const fetchBehaviourSpecialisations = (streamId, assessmentAssignedId) => async (dispatch) => {
  try {
    dispatch({ type: ASSESSMENT_TYPES.FETCH_BEHAVIOUR_SPECIALISATIONS_REQUEST })
    const params = new URLSearchParams({ stream_id: streamId })
    if (assessmentAssignedId) params.append('assessment_assigned_id', assessmentAssignedId)
    const response = await studentRequest.get(
      `students/getBehaviourSpecialisations?${params.toString()}`
    )
    const payload = response?.data?.data || { specialisations: [], mappedSpecialisationIds: [], savedSpecialisationIds: [] }
    dispatch({
      type: ASSESSMENT_TYPES.FETCH_BEHAVIOUR_SPECIALISATIONS_SUCCESS,
      payload,
    })
    return payload
  } catch (error) {
    console.error('Error fetching behaviour specialisations:', error)
    dispatch({
      type: ASSESSMENT_TYPES.FETCH_BEHAVIOUR_SPECIALISATIONS_FAILURE,
      payload: error.message,
    })
    return { specialisations: [], mappedSpecialisationIds: [], savedSpecialisationIds: [] }
  }
}

export const saveBehaviourSpecialisation = (assessmentAssignedId, specialisationIds) => async (dispatch) => {
  try {
    dispatch({ type: ASSESSMENT_TYPES.SAVE_BEHAVIOUR_SPECIALISATION_REQUEST })
    const ids = Array.isArray(specialisationIds) ? specialisationIds : (specialisationIds ? [specialisationIds] : [])
    const response = await studentRequest.post(
      'students/saveBehaviourSpecialisation',
      { assessment_assigned_id: assessmentAssignedId, specialisation_ids: ids }
    )
    dispatch({
      type: ASSESSMENT_TYPES.SAVE_BEHAVIOUR_SPECIALISATION_SUCCESS,
      payload: response?.data?.data,
    })
    return response?.data?.data
  } catch (error) {
    console.error('Error saving behaviour specialisation:', error)
    dispatch({
      type: ASSESSMENT_TYPES.SAVE_BEHAVIOUR_SPECIALISATION_FAILURE,
      payload: error.message,
    })
    throw error
  }
}